export const autocollection = [
  {
    name: 'Corona Regulation',
    content: [
      {
        name: 'Corona Laws',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'bill',
                  input: 'bill',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'law',
                  input: 'law',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'Gesetzesvorlage ',
                  input: 'Gesetzesvorlage ',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'Gesetzgebung',
                  input: 'Gesetzgebung',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'Gesetz',
                  input: 'Gesetz',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'SARS-CoV-2',
                  input: 'SARS-CoV-2',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid 19',
                  input: 'covid 19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona-virus',
                  input: 'corona-virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona virus',
                  input: 'corona virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid-19',
                  input: 'covid-19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'coronavirus',
                  input: 'coronavirus',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: true,
                  field: 'text',
                  name: '',
                  value: 'stimulus',
                  input: 'stimulus',
                },
                {
                  negated: true,
                  field: 'text',
                  name: '',
                  value: 'bailout',
                  input: 'bailout',
                },
                {
                  negated: true,
                  field: 'text',
                  name: '',
                  value: 'package',
                  input: 'package',
                },
                {
                  negated: true,
                  field: 'text',
                  name: '',
                  value: 'law enforcement',
                  input: 'law enforcement',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'new',
                  input: 'new',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'neue',
                  input: 'neue',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'debating',
                  input: 'debating',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'voting',
                  input: 'voting',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'vote',
                  input: 'vote',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'Abstimmen',
                  input: 'Abstimmen',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'stimmen',
                  input: 'stimmen',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'verabschieden',
                  input: 'verabschieden',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'proposed',
                  input: 'proposed',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'proposal',
                  input: 'proposal',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'pass',
                  input: 'pass',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Monetary Policy',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'Stimulus',
                  input: 'Stimulus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'REPO',
                  input: 'REPO',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'bond purchase',
                  input: 'bond purchase',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'liquidty',
                  input: 'liquidty',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'SARS-CoV-2',
                  input: 'SARS-CoV-2',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid 19',
                  input: 'covid 19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona-virus',
                  input: 'corona-virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona virus',
                  input: 'corona virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid-19',
                  input: 'covid-19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'coronavirus',
                  input: 'coronavirus',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'fiscal',
                  input: 'fiscal',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'package',
                  input: 'package',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'monetary policy',
                  input: 'monetary policy',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'recession',
                  input: 'recession',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'economic',
                  input: 'economic',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Fiscal Policy',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'policy',
                  input: 'policy',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'regulations',
                  input: 'regulations',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'Law',
                  input: 'Law',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'bill',
                  input: 'bill',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'SARS-CoV-2',
                  input: 'SARS-CoV-2',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid 19',
                  input: 'covid 19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona-virus',
                  input: 'corona-virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona virus',
                  input: 'corona virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid-19',
                  input: 'covid-19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'coronavirus',
                  input: 'coronavirus',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'fiscal',
                  input: 'fiscal',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'package',
                  input: 'package',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'stimulus',
                  input: 'stimulus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'bailout',
                  input: 'bailout',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'funding',
                  input: 'funding',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'package',
                  input: 'package',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Corporate Stimulus',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'SARS-CoV-2',
                  input: 'SARS-CoV-2',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid 19',
                  input: 'covid 19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona-virus',
                  input: 'corona-virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona virus',
                  input: 'corona virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid-19',
                  input: 'covid-19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'coronavirus',
                  input: 'coronavirus',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'bailout',
                  input: 'bailout',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'special loan',
                  input: 'special loan',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'relief package',
                  input: 'relief package',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'small businesses',
                  input: 'small businesses',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'big businesses',
                  input: 'big businesses',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'small business',
                  input: 'small business',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'big business',
                  input: 'big business',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'distressed business',
                  input: 'distressed business',
                },
                {
                  negated: false,
                  field: 'event',
                  name: 'Bankruptcy/Insolvency',
                  value: 'E_10',
                  input: 'bankr',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Payroll Protection',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'payroll protection',
                  input: 'payroll protection',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'payroll grant',
                  input: 'payroll grant',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'payroll protection grant',
                  input: 'payroll protection grant',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'payroll',
                  input: 'payroll',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'wages',
                  input: 'wages',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: "worker's wages",
                  input: "worker's wages",
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'SARS-CoV-2',
                  input: 'SARS-CoV-2',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid 19',
                  input: 'covid 19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona-virus',
                  input: 'corona-virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'corona virus',
                  input: 'corona virus',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'covid-19',
                  input: 'covid-19',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'coronavirus',
                  input: 'coronavirus',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'fiscal',
                  input: 'fiscal',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'package',
                  input: 'package',
                },
              ],
              groups: [],
            },
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'layoff',
                  input: 'layoff',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'avoid',
                  input: 'avoid',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'avoiding',
                  input: 'avoiding',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'prevent',
                  input: 'prevent',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'unpaid leave',
                  input: 'unpaid leave',
                },
                {
                  negated: false,
                  field: 'text',
                  name: '',
                  value: 'layoffs',
                  input: 'layoffs',
                },
              ],
              groups: [],
            },
          ],
        },
      },
    ],
  },
  {
    name: 'Risk Screening',
    content: [
      {
        name: 'Organisational Risk',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'C-Level Stepping Down/Being Fired',
                  value: 'E8_A',
                  input: 'C-Lev',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Restructure/Job Cuts',
                  value: 'E13_A',
                  input: 'Restr',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Company Restructure',
                  value: 'E42_C',
                  input: 'Company Restr',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Reorganization',
                  value: 'E42_A',
                  input: 'Reorgani',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Short-Time Work',
                  value: 'E13_B',
                  input: 'Short-',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Production Risk',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Plant Closure',
                  value: 'E35_B',
                  input: 'Plant clo',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Delivery/Logistics Problems',
                  value: 'E15_A',
                  input: 'Delivery',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Production Decrease',
                  value: 'E10_B',
                  input: 'Production Dec',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Product Recall',
                  value: 'E3_A',
                  input: 'Product Re',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Environmental Compliance Risk',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Fossil Fuels Exploitation',
                  value: 'E33_D',
                  input: 'Fossil Fu',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Violation of CO2 Regulations',
                  value: 'E25_E',
                  input: 'Violation of',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Violation of Environmental Regulations',
                  value: 'E25_B',
                  input: 'Violation',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Greenwashing',
                  value: 'E32_C',
                  input: 'Greenwas',
                },
              ],
              groups: [],
            },
          ],
        },
      },
      {
        name: 'Financial Risk',
        query: {
          operator: 'and',
          filters: [],
          groups: [
            {
              operator: 'or',
              slop: 5,
              filters: [
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Bankruptcy Threat',
                  value: 'E18_D',
                  input: 'Bankru',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Bankruptcy',
                  value: 'E18_A',
                  input: 'bankrupt',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Insolvency',
                  value: 'E18_B',
                  input: 'Insolvenc',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Insolvency Threat',
                  value: 'E18_E',
                  input: 'Insolvency',
                },
                {
                  negated: false,
                  field: 'sub_event',
                  name: 'Liquidity Threat',
                  value: 'E18_F',
                  input: 'Liquidi',
                },
              ],
              groups: [],
            },
          ],
        },
      },
    ],
  },
];
